import { Branch } from '@texas/api/endpoints/branchesApi';

let selectedBranchId: number | null = null;

export function getConfigurationBranchId(branches: Branch[]) {
  if (branches.some((branch) => branch.id === selectedBranchId)) {
    return selectedBranchId ?? 0;
  }

  const firstBranchId = branches[0]?.id ?? 0;
  selectedBranchId = firstBranchId || null;
  return firstBranchId;
}

export function setConfigurationBranchId(branchId: number) {
  selectedBranchId = branchId;
}
